module.exports = __webpack_public_path__ + "img/page-20.ecca2c52.jpg";